import React, { useState } from "react";
import shapeImg1 from "../../assets/img/newsletter/shape-1-1.png";
import shapeImg2 from "../../assets/img/newsletter/shape-1-2.png";
import shapeImg3 from "../../assets/img/newsletter/shape-1-3.png";
import shapeImg4 from "../../assets/img/newsletter/shape-1-4.png";
import { createSubscription } from "../../services/subscriptionService";
import toast from "react-hot-toast";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubscribe = async () => {
    if (!email.trim()) {
      setError("Email is required");
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setError("");

    try {
      const res = await createSubscription({ email });
      toast.success(res.message || "Subscribed successfully!");
      setEmail("");
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    }
  };

  return (
    <div className="it-newsletter-area it-newsletter-height fix p-relative theme-bg mt-50">
      <div className="it-newsletter-shape-1 d-none d-lg-block">
        <img src={shapeImg1} alt="" />
      </div>
      <div className="it-newsletter-shape-2 d-none d-lg-block">
        <img src={shapeImg2} alt="" />
      </div>
      <div className="it-newsletter-shape-3 d-none d-xl-block">
        <img src={shapeImg3} alt="" />
      </div>
      <div className="it-newsletter-shape-4 d-none d-xl-block">
        <img src={shapeImg4} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-6 col-lg-6 col-md-6">
            <div className="it-newsletter-left">
              <h4 className="ed-section-title text-white pb-20">
                Subscribe to Our Newsletter
              </h4>
              <span>
                Stay updated with the latest SAP news, events, and aquaculture
                insights—delivered straight to your inbox.
              </span>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6">
            <div className="it-newsletter-right p-relative text-end">
              <input
                type="text"
                placeholder="Enter your email:"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setError(""); // clear error on change
                }}
              />
              <button
                className="it-btn black-bg"
                type="button"
                onClick={handleSubscribe}
              >
                <span>subscribe now</span>
              </button>
            </div>
            {error && (
              <p
                className="text-danger mt-2 ml-[80px]"
                style={{ color: "#ff4d4f" }}
              >
                {error}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
